<template>
    <div class="offcanvas mobile-filter is-left">
        <button class="btn btn-block offcanvas-close" @click="closeFilter()">
            {{ $translate("Ceres::Template.itemFilter") }}
            <svg class="icon icon-x" width="32" height="32" fill="currentColor">
                <use xlink:href="#x" />
            </svg>
        </button>
        <div class="p-3">
            <client-only>
                <item-filter :filter-type="filterType" :is-mobile="true" v-for="facet in facets" :facet="facet" :key="facet.id"></item-filter>
            </client-only>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import ItemFilter from "./ItemFilter.vue";
export default {
    name: 'mobile-filter',
    components:
        {
            ItemFilter
        },
    props: {
        filterType: {
            type: String,
            default: 'dropdown'
        },
        facetData:
            {
                type: Array,
                default()
                {
                    return [];
                }
            },
    },

    computed:
        {
            ...mapState({
                facets(state)
                {
                    return state.itemList.facets;
                },
                isLoading: state => state.itemList.isLoading,
                selectedFacets: state => state.itemList.selectedFacets
            })
        },

        created()
        {
            if (!this.$store.state.itemList.facets?.length)
            {
                this.$store.commit("addFacets", this.facetData);
            }
        },

    methods:{
        closeFilter()
        {
            document.querySelector(".mobile-filter").classList.remove("open");
            document.querySelector("body").classList.remove("menu-is-visible");
        },
    }
};
</script>
